import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { OFERTA_PATH } from '../legal/operator';

export default function RegisterForm({ teacherUsername }) {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    first_name: '',
    contact_channel: 'email',
    pdn_consent: false,
    oferta_accepted: false,
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!formData.pdn_consent) {
      setError('Отметьте отдельное согласие на обработку персональных данных');
      return;
    }
    if (!formData.oferta_accepted) {
      setError('Необходимо принять договор-оферту');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const payload = {
        username: formData.username,
        email: formData.email,
        password: formData.password,
        first_name: formData.first_name,
        contact_channel: formData.contact_channel,
        pdn_consent: formData.pdn_consent,
      };
      if (teacherUsername) {
        payload.teacher = teacherUsername;
      }
      await register(payload);
      navigate('/questionnaire?from=register');
    } catch (err) {
      const data = err.response?.data;
      if (data && typeof data === 'object') {
        const messages = Object.entries(data)
          .map(([key, val]) => `${key}: ${Array.isArray(val) ? val.join(', ') : val}`)
          .join('; ');
        setError(messages);
      } else {
        setError('Ошибка регистрации');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      {error && <div className="alert alert-error">{error}</div>}
      <div className="form-group">
        <label htmlFor="first_name">Имя</label>
        <input
          id="first_name"
          name="first_name"
          type="text"
          value={formData.first_name}
          onChange={handleChange}
          placeholder="Ваше имя"
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="username">Имя пользователя</label>
        <input
          id="username"
          name="username"
          type="text"
          value={formData.username}
          onChange={handleChange}
          placeholder="Придумайте логин"
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="your@email.com"
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="password">Пароль</label>
        <div style={{ position: 'relative' }}>
          <input
            id="password"
            name="password"
            type={showPassword ? 'text' : 'password'}
            value={formData.password}
            onChange={handleChange}
            placeholder="Минимум 8 символов"
            required
            minLength={8}
            style={{ paddingRight: '2.6rem' }}
          />
          <button
            type="button"
            className="btn btn-outline btn-xs"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
            title={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
            style={{
              position: 'absolute',
              right: '0.4rem',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden />
          </button>
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="contact_channel">Канал связи</label>
        <select
          id="contact_channel"
          name="contact_channel"
          value={formData.contact_channel}
          onChange={handleChange}
        >
          <option value="email">Email</option>
          <option value="max">Макс</option>
          <option value="phone">Телефон</option>
        </select>
      </div>
      <fieldset className="pdn-consent-block">
        <legend>Согласие на обработку персональных данных</legend>
        <label className="pdn-consent-label">
          <input
            type="checkbox"
            name="pdn_consent"
            checked={formData.pdn_consent}
            onChange={handleChange}
          />
          <span>
            Даю отдельное согласие на обработку персональных данных, в том числе
            логина и адреса электронной почты.{' '}
            <Link to="/consent" target="_blank" rel="noopener noreferrer">
              Текст согласия
            </Link>
          </span>
        </label>
      </fieldset>
      <div className="form-group checkbox-group">
        <label>
          <input
            type="checkbox"
            name="oferta_accepted"
            checked={formData.oferta_accepted}
            onChange={handleChange}
          />
          <span>
            Принимаю{' '}
            <Link to={OFERTA_PATH} target="_blank" rel="noopener noreferrer">
              договор-оферту
            </Link>
          </span>
        </label>
      </div>
      <p className="auth-legal-note">
        <Link to="/privacy" target="_blank" rel="noopener noreferrer">
          Политика обработки ПДн
        </Link>
      </p>
      <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
        {loading ? 'Регистрация...' : 'Зарегистрироваться'}
      </button>
    </form>
  );
}
